import { render, staticRenderFns } from "./shoppingcart.vue?vue&type=template&id=1c49ba85&scoped=true"
import script from "./shoppingcart.vue?vue&type=script&lang=js"
export * from "./shoppingcart.vue?vue&type=script&lang=js"
import style0 from "./shoppingcart.vue?vue&type=style&index=0&id=1c49ba85&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c49ba85",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c49ba85')) {
      api.createRecord('1c49ba85', component.options)
    } else {
      api.reload('1c49ba85', component.options)
    }
    module.hot.accept("./shoppingcart.vue?vue&type=template&id=1c49ba85&scoped=true", function () {
      api.rerender('1c49ba85', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/shoppingcart/shoppingcart.vue"
export default component.exports